import React, { FC } from 'react'
import { Oval } from 'react-loader-spinner'

const Spinner = ({ className, height = 50, width = 50, color = "#2563eb" }) => {
    return (
        <div className={`flex justify-center ${className}`}>
            <Oval
                visible={true}
                height={height}          // number, not string
                width={width}           // number, not string
                color={color}
                secondaryColor=""
                ariaLabel="oval-loading"
                wrapperStyle={{}}
                wrapperClass=""
            />
        </div>
    );
};

export default Spinner;
